import { Version } from '@repo/toolkit/types'

import { TripBookingVersionMap } from '../../lib/types/models/trip-booking/trip-booking'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripBooking<T extends Version>(
  id: number,
  version: T
): Promise<TripBookingVersionMap[T]> {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API['trip-bookings'].get.url, { id }), { version }))
    .get<TripBookingVersionMap[T]>()
}
